<template>
	<div>
		<v-main>
			<v-container>
				<v-layout wrap>
				</v-layout>
			</v-container>
		</v-main>
	</div>
</template>
<script>



import { mapGetters, mapActions, mapMutations } from 'vuex';
export default {
	name: 'Expired',
	data() {
		return {
		};
	},
	computed: {
		...mapGetters({}),
	},
	methods: {
		...mapActions({
		}),
		...mapMutations({
		}),
	},
	async created() {

	},
};
</script>
